import type { CheckResult } from "./types";

export type CroPublicChannelId = "forms" | "chat" | "browser_call" | "phone" | "sms" | "email";

export const CRO_PUBLIC_CHANNELS: {
  id: CroPublicChannelId;
  label: string;
  question: string;
  checkIds: readonly string[];
}[] = [
  {
    id: "forms",
    label: "Website Forms",
    question: "Can a visitor complete a form without friction?",
    checkIds: ["form_or_alternate", "field_count", "form_labels", "form_errors", "P-L02", "responsive_inputs", "CF-CAPTURE", "CF-BROKEN"],
  },
  {
    id: "chat",
    label: "AI Live Chat",
    question: "Can a visitor start chat and reach a complete path?",
    checkIds: ["P-C01", "P-A04", "live_assistance", "ai_disclosure", "CF-INTERACT", "CF-INTENT", "CF-HANDOFF"],
  },
  {
    id: "browser_call",
    label: "AI WebRTC Browser Calls",
    question: "Can someone start a browser-native call?",
    checkIds: ["P-C02", "CF-INTERACT", "CF-HANDOFF"],
  },
  {
    id: "phone",
    label: "AI Phone Calls",
    question: "Can someone find and complete a phone path?",
    checkIds: ["phone_or_hours", "P-C02", "CF-ENTRY", "CF-HANDOFF"],
  },
  {
    id: "sms",
    label: "AI Text Messaging",
    question: "Can someone text and get a timely reply path?",
    checkIds: ["P-C03", "email_or_sms", "CF-ENTRY"],
  },
  {
    id: "email",
    label: "AI Email Support",
    question: "Can someone email and reach the right team?",
    checkIds: ["P-C04", "email_or_sms", "privacy_link", "CF-HANDOFF"],
  },
];

export function croChecksForChannel(checks: CheckResult[], channelId: CroPublicChannelId): CheckResult[] {
  const ids = new Set(CRO_PUBLIC_CHANNELS.find((channel) => channel.id === channelId)?.checkIds ?? []);
  const byId = new Map(checks.map((check) => [check.id, check]));
  return [...ids].flatMap((id) => {
    const check = byId.get(id);
    return check ? [check] : [];
  });
}
